export interface IObservableSubscription {
    dispose(): void;
}

interface IObserver {
    onNext: (data?: any) => void,
    onError: (err?: any) => void,
    onCompleted: () => void
}

export default class Observable {

    private _publisher: (observer: IObserver) => IObservableSubscription;

    constructor(publisher: (observer: IObserver) => IObservableSubscription) {
        this._publisher = publisher;
    }

    forEach(onNext: (data?: any) => void,
            onError?: (err?: any) => void,
            onCompleted?: () => void) : IObservableSubscription  {

        let observer = {
            onNext: onNext,
            onError: onError || (() => {}),
            onCompleted: onCompleted || (() => {})
        };

        return this._publisher(observer);
    }

}